export const enum AllRecordType {
  INCIDENT = 'INCIDENT',
  CAPA = 'CAPA',
  FOLLOWUP = 'FOLLOWUP',
}
